import React from 'react';
import { Link } from "react-router-dom";

export function Footer() {
    return (
        <div className='row section py-5 px-0 px-md-5'>
            <div className='col-12 col-md-6'>
                Looking for a boat and captain for multiple hours? Check out our weekday charters!
            </div>
            <div className='col-12 col-md-6 col-6 text-center text-md-right mt-4 mt-md-0'>
                <a href='https://www.lakeozarkswatertaxi.com/weekday-charters' className='btn'>Weekday Charters</a>
            </div>
        </div>
    )
}